import Galeria1 from "./GalleriaShophouse.png";
import Galeria2 from "./GalleriaShophouse.png";

const galeria = [Galeria1, Galeria2];
export default galeria;
